import { CountryCode, Locale } from '@/utility/locale';

export const DEFAULT_ALP_SORT: AssortmentListPageSort = 'weight';
export const DEFAULT_PLP_SORT: ProductListPageSort = 'weight';
export const DEFAULT_SHOWROOM_SORT: ProductListPageSort = 'weight';
export const MATERIAL_SUSTAINABLE_ID = 'MAT_3';
export const FEATURE_SUSTAINABLE_ID = 'F1';
export const FEATURE_EMBROIDERY_ID = 'F11';
export const WARNING_NO_BLANK_ID = 'W1';
export const ALL_RATINGS = '1,2,3,4,5';
export const MAX_QUANTITY = 10000;
export const MAX_FAVORITES = 100;
export const KIDS_DEPARTMENT_ID = 'KIDS';
export const UNISEX_DEPARTMENT_ID = 'UNISEX';
export const SALE_CATEGORY_ID = '5000';
export const MATERIAL_VIEW_ID = '12';
export const EMBROIDERY_PRINT_TYPE_IDS = ['8', '33', '34', '35', '46'];
export const CONTENT_SERVICE_FALLBACK_CATEGORY_ID = '118636'; // old "Gifts" category as fallback for dynamic content
// No car stickers, because "they don't perform well".
export const STICKER_PRODUCT_TYPE_IDS = ['1459'];

/** @deprecated abTest cookie is deprecated, use kameleoon abTests instead */
export const AB_TEST_COOKIE = 'AB-Tests';

// https://spaces.spreadomat.net/pages/viewpage.action?pageId=36504297
export const MP_SHOPS: Partial<Record<Locale, { shopId: string; editShopId: string }>> = {
  'de-DE': { shopId: '200023259', editShopId: '783914' },
  'de-AT': { shopId: '200023261', editShopId: '591997' },
  'en-GB': { shopId: '200022669', editShopId: '629655' },
  'en-IE': { shopId: '210000453', editShopId: '404968' },
  'fr-FR': { shopId: '200022663', editShopId: '595780' },
  'de-CH': { shopId: '210000455', editShopId: '858469' },
  'fr-CH': { shopId: '210000455', editShopId: '858473' },
  'it-CH': { shopId: '210000455', editShopId: '858475' },
  'nl-NL': { shopId: '210000457', editShopId: '595765' },
  'nl-BE': { shopId: '210000459', editShopId: '595786' },
  'fr-BE': { shopId: '210000459', editShopId: '595784' },
  'no-NO': { shopId: '210000461', editShopId: '595768' },
  'fi-FI': { shopId: '210000463', editShopId: '595964' },
  'sv-SE': { shopId: '210000465', editShopId: '595776' },
  'da-DK': { shopId: '210000467', editShopId: '595778' },
  'es-ES': { shopId: '200022665', editShopId: '595774' },
  'it-IT': { shopId: '200022667', editShopId: '595772' },
  'pl-PL': { shopId: '210000469', editShopId: '595770' },
  'en-US': { shopId: '93439', editShopId: '349065' },
  'fr-CA': { shopId: '300000007', editShopId: '371368' },
  'en-CA': { shopId: '300000007', editShopId: '349069' },
  'en-AU': { shopId: '300000009', editShopId: '588650' },
} as const;

export const MP_PRICE_GROUP_SHOPS: Partial<
  Record<CountryCode, Record<number, { shopId: string; editShopId: string }>>
> = {
  AT: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  BE: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  CH: { 2: { shopId: '1162332', editShopId: '1162333' } },
  DE: {
    1: { shopId: '101096814', editShopId: '101096787' },
    2: { shopId: '101096786', editShopId: '101096815' },
  },
  ES: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  FI: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  FR: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  IE: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  IT: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
  NL: {
    1: { shopId: '101084015', editShopId: '101084078' },
    2: { shopId: '101084035', editShopId: '101084079' },
  },
} as const;

export const MP_PARTNER_PRICE_GROUPS: Record<string, number> = {
  '2286205': 1,
  '124991195': 1,
  '127993413': 2,
  '210491553': 2,
} as const;

export const RECAPTCHA_SITE_KEY = '6Lf43OQrAAAAAFCiAtA-ySNyfrjSZdmp17qXfK7J'; // https://console.cloud.google.com/security/recaptcha/6Lf43OQrAAAAAFCiAtA-ySNyfrjSZdmp17qXfK7J/integration?project=customer-journey-474707
